import { connect } from "react-redux";
import { mapStateToProps } from "../../store/helpers/mapState";
import { mapDispatchToProps } from "../../store/helpers/mapDispatch";
import { useHistory, useParams } from "react-router";
import React, { useEffect, useState } from "react";
import { getMonthIcon, getMonth, monthList } from "../../helpers/Common_functions";
import { BottomNavigation, BottomNavigationAction, Button, FormControl, IconButton, Typography } from "@mui/material";
import { getError } from "../../store/helpers/common_functions";
import PageLoading from "../../helpers/PageLoading";
import QtMaterialButton from "../../components/QtMaterialButton";
import moment from "moment";
import Select from "@mui/material/Select";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import WorklogReportContent from "./WorklogReportContent";
import { ArrowCircleDown, InfoOutlined } from "@mui/icons-material";
import SelectEmployee from "../../helpers/SelectEmployee";
import { ArrowDropDown } from "@material-ui/icons";

const WorklogPersonalReport = ({ FetchDetails, loggedUser, GetLoggedUser, GetAllResources, resources }) => {
    const { id } = useParams();
    const [error, setError] = useState(null);
    const [months, setMonths] = useState([]);
    const [activeTab, setActiveTab] = useState(0);
    const [activeMonth, setActiveMonth] = useState(0);
    const [info, setInfo] = useState(null);
    const [loading, setLoading] = useState(false);
    const [openModal, setOpenModal] = useState(false);
    const [active, setActive] = useState(id);
    const currentYear = new Date().getFullYear();
    const yr = [];
    for (let i = currentYear; i >= currentYear - 10; i--) {
        yr.push({ year: i, count: 0 });
    }
    const [years, setYears] = useState(yr);
    const [activeYear, setActiveYear] = useState(currentYear);
    const [dates, setDates] = useState([]);

    useEffect(() => {
        setActive(id);
    }, [id]);

    useEffect(() => {
        GetLoggedUser();
        GetAllResources();
    }, [GetLoggedUser]);


    const getNumDays = () => {
        return moment(`${activeYear}-${months[activeTab]?.month}`, "YYYY-M").daysInMonth();
    }

    useEffect(() => {
        if (months.length - 1 >= activeTab) {
            const num = getNumDays();
            let arr = [];
            for (let i = 1; i <= num; i++) {
                arr.push({ label: i });
            }
            setDates(arr);
            setActiveMonth(months[activeTab]?.month);
        }
    }, [activeTab, months, active]);


    const loadMonths = async () => {
        const resp = await FetchDetails(`/api/worklogs/report/months/${active}${activeYear ? `?year=${activeYear}` : ''}`);
        if (resp.status) {
            const years = resp.data.years;
            const months = monthList?.map((month) => {
                const isMonthExist = resp.data.months?.find((item) => item?.month === month.value)

                return { month: month.value, year: isMonthExist ? isMonthExist?.year : activeYear, count: isMonthExist ? isMonthExist?.count : 0 }
            })

            setMonths(months);

            // setYears(years);
            // if (years.filter(v => v.year === activeYear).length <= 0 && years.length) {
            //     setActiveYear(years[0].year);
            // }
        }
    }

    const history = useHistory();


    const isMe = active === loggedUser?.resourceId;
    const loadProfileData = async () => {
        setLoading(true);
        setError(null);
        const resp = await FetchDetails(isMe ? `/api/profile/details` : `/api/resource/details/${active}`);
        setLoading(false);
        if (resp.status) {
            setInfo(resp.data);
        } else {
            setError(getError(resp));
        }
        return resp;
    }

    useEffect(() => {
        loadMonths().then();
    }, [activeYear, active]);

    useEffect(() => {
        loadProfileData().then();
    }, [active]);

    return (loading && !info) || error || !info ? <PageLoading error={loading ? null : error} onRefresh={loadProfileData} /> : <div className={'h-full'}>
        {openModal && <SelectEmployee onClose={() => setOpenModal(false)} open={openModal} resources={resources?.data ?? []} onChange={(resource) => {
            setActive(resource?.id);
            setOpenModal(false);
        }} />}
        <div className={'flex h-full flex-col'}>
            <div className={'flex items-center fixed w-full bg-white top-0 p-2 shadow border-bottom'}>
                <div>
                    <Typography variant={'h5'}>
                        {info.resource.names}
                    </Typography>
                    <div>
                        <Typography variant={'body2'}>
                            {info.resource.category}
                        </Typography>
                    </div>
                </div>
                {loggedUser?.allowProject && <div>
                    <IconButton onClick={() => {
                        setOpenModal(true);
                    }}>
                        <ArrowDropDown />
                    </IconButton>
                </div>}
                <div className={'flex-grow'}>
                    <BottomNavigation
                        showLabels
                        value={activeTab}
                        onChange={(event, newValue) => {
                            setActiveTab(newValue);
                        }}
                    >
                        {months.map((el, index) => <BottomNavigationAction value={index} label={getMonth(el.month)} icon={getMonthIcon(el.month)} />)}
                    </BottomNavigation>
                </div>
                <div className={'mr-3'} style={{ width: "100px" }}>
                    <FormControl size={'small'} variant={'standard'} fullWidth>
                        {/*<InputLabel id="demo-simple-select-label">Select Year</InputLabel>*/}
                        <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={activeYear}
                            placeholder="Select Year"
                            onChange={(e) => {
                                setActiveYear(e.target.value);
                            }}
                        >
                            {years.map(v =>
                                <MenuItem value={v.year}>{v.year}</MenuItem>)}
                        </Select>
                    </FormControl>
                </div>
                <div>
                    <QtMaterialButton onClick={() => {
                        history.push(`/admin/profile/${id}`);
                    }} variant={'contained'} className={'bg-qt'}>Homepage</QtMaterialButton>
                </div>
            </div>
            <div className={'flex-grow mt-20'}>
                {!months.length ? <div className={'h-full flex items-center justify-center'}>
                    <div className={'text-center'}>
                        <div><InfoOutlined style={{ fontSize: "40px" }} /></div>
                        <div>
                            <Typography>No Report data found !</Typography>
                        </div>
                    </div>
                </div> : <WorklogReportContent resource={info.resource} dates={dates} year={activeYear} month={activeMonth} />}
            </div>
        </div>
    </div>;
}

export default connect(mapStateToProps, mapDispatchToProps)(WorklogPersonalReport);